export { default } from './HighlightHero'
